import { render, staticRenderFns } from "./OrderDetailsTable.vue?vue&type=template&id=442bc9c9&"
import script from "./OrderDetailsTable.vue?vue&type=script&lang=ts&"
export * from "./OrderDetailsTable.vue?vue&type=script&lang=ts&"
import style0 from "./OrderDetailsTable.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VAvatar } from 'vuetify/lib/components/VAvatar';
import { VDataTable } from 'vuetify/lib/components/VDataTable';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VTooltip } from 'vuetify/lib/components/VTooltip';
installComponents(component, {VAvatar,VDataTable,VIcon,VTooltip})
